import React from 'react';
import { DollarSignIcon, TrendingUpIcon, SettingsIcon } from 'lucide-react';
export function ModelMarketplace() {
  const models = [{
    id: 1,
    name: 'Healthcare ABM Model',
    industry: 'Healthcare',
    basePrice: 299,
    markup: 40,
    finalPrice: 419,
    sales: 23,
    revenue: 9637
  }, {
    id: 2,
    name: 'FinTech Lead Scoring',
    industry: 'Financial Services',
    basePrice: 199,
    markup: 50,
    finalPrice: 299,
    sales: 41,
    revenue: 12259
  }, {
    id: 3,
    name: 'Manufacturing Pipeline Model',
    industry: 'Manufacturing',
    basePrice: 249,
    markup: 35,
    finalPrice: 336,
    sales: 18,
    revenue: 6048
  }];
  return <div className="max-w-7xl mx-auto" data-id="element-2113">
      {/* Header */}
      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-lg p-6 mb-6 text-white" data-id="element-2114">
        <h2 className="text-2xl font-bold mb-2" data-id="element-2115">
          Industry-Specific Model Marketplace
        </h2>
        <p className="text-indigo-100" data-id="element-2116">
          Sell pre-trained GTM models with custom pricing and markup controls
        </p>
      </div>
      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-2117">
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2118">
          <div className="flex items-center gap-3 mb-2" data-id="element-2119">
            <DollarSignIcon className="w-5 h-5 text-green-600" data-id="element-2120" />
            <p className="text-sm text-gray-600" data-id="element-2121">Total Revenue</p>
          </div>
          <p className="text-3xl font-bold text-gray-900" data-id="element-2122">$27,944</p>
          <div className="flex items-center gap-1 text-sm text-green-600 mt-2" data-id="element-2123">
            <TrendingUpIcon className="w-4 h-4" data-id="element-2124" />
            <span data-id="element-2125">+18% this month</span>
          </div>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2126">
          <div className="flex items-center gap-3 mb-2" data-id="element-2127">
            <TrendingUpIcon className="w-5 h-5 text-blue-600" data-id="element-2128" />
            <p className="text-sm text-gray-600" data-id="element-2129">Total Sales</p>
          </div>
          <p className="text-3xl font-bold text-gray-900" data-id="element-2130">82</p>
          <div className="flex items-center gap-1 text-sm text-green-600 mt-2" data-id="element-2131">
            <TrendingUpIcon className="w-4 h-4" data-id="element-2132" />
            <span data-id="element-2133">+12% this month</span>
          </div>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2134">
          <div className="flex items-center gap-3 mb-2" data-id="element-2135">
            <SettingsIcon className="w-5 h-5 text-purple-600" data-id="element-2136" />
            <p className="text-sm text-gray-600" data-id="element-2137">Active Models</p>
          </div>
          <p className="text-3xl font-bold text-gray-900" data-id="element-2138">3</p>
          <p className="text-sm text-gray-600 mt-2" data-id="element-2139">Across 3 industries</p>
        </div>
      </div>
      {/* Models Table */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2140">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-2141">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-2142">Your Models</h3>
        </div>
        <table className="w-full" data-id="element-2143">
          <thead className="bg-gray-50 border-b border-gray-200" data-id="element-2144">
            <tr data-id="element-2145">
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase" data-id="element-2146">
                Model Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase" data-id="element-2147">
                Industry
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase" data-id="element-2148">
                Base Price
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase" data-id="element-2149">
                Markup
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase" data-id="element-2150">
                Your Price
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase" data-id="element-2151">
                Sales
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase" data-id="element-2152">
                Revenue
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase" data-id="element-2153">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-2154">
            {models.map(model => <tr key={model.id} className="hover:bg-gray-50" data-id="element-2155">
                <td className="px-6 py-4" data-id="element-2156">
                  <p className="font-medium text-gray-900" data-id="element-2157">{model.name}</p>
                </td>
                <td className="px-6 py-4" data-id="element-2158">
                  <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded-full" data-id="element-2159">
                    {model.industry}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-2160">
                  <p className="text-gray-900" data-id="element-2161">${model.basePrice}</p>
                </td>
                <td className="px-6 py-4" data-id="element-2162">
                  <p className="text-gray-900" data-id="element-2163">{model.markup}%</p>
                </td>
                <td className="px-6 py-4" data-id="element-2164">
                  <p className="font-semibold text-gray-900" data-id="element-2165">
                    ${model.finalPrice}
                  </p>
                </td>
                <td className="px-6 py-4" data-id="element-2166">
                  <p className="text-gray-900" data-id="element-2167">{model.sales}</p>
                </td>
                <td className="px-6 py-4" data-id="element-2168">
                  <p className="font-semibold text-gray-900" data-id="element-2169">
                    ${model.revenue.toLocaleString()}
                  </p>
                </td>
                <td className="px-6 py-4" data-id="element-2170">
                  <button className="text-red-600 hover:text-red-700 text-sm font-medium" data-id="element-2171">
                    Edit
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}